import { initializeApp } from 'firebase/app'
import {
  GoogleAuthProvider,
  browserLocalPersistence,
  getAuth,
  setPersistence,
} from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'

function required(name: string): string {
  const value = import.meta.env[name] as string | undefined
  if (!value) throw new Error(`Missing ${name}. Copy .env.example to .env.`)
  return value
}

/**
 * The SAME Firebase project as the app. Admin edits the events and series that
 * the app reads, so they must share a database; the separation between them is
 * authorization, not a different backend.
 */
export const firebaseApp = initializeApp({
  apiKey: required('VITE_FIREBASE_API_KEY'),
  authDomain: required('VITE_FIREBASE_AUTH_DOMAIN'),
  projectId: required('VITE_FIREBASE_PROJECT_ID'),
  storageBucket: required('VITE_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: required('VITE_FIREBASE_MESSAGING_SENDER_ID'),
  appId: required('VITE_FIREBASE_APP_ID'),
})

export const auth = getAuth(firebaseApp)
export const db = getFirestore(firebaseApp)

/** Callable functions. Pinned to the region the functions are deployed in —
 *  the default is us-central1, and a mismatch fails as a CORS error rather
 *  than as anything that names the real problem. */
export const functions = getFunctions(firebaseApp, 'europe-west4')

/**
 * Sessions live in origin-scoped IndexedDB, so signing in at app.racedash.live
 * grants nothing here — an admin signs in again. That separation is enforced by
 * the browser rather than by our code, which is why authDomain is this app's own
 * origin and not shared with the app.
 */
void setPersistence(auth, browserLocalPersistence)

export const googleProvider = new GoogleAuthProvider()
